import { useIntl } from 'react-intl';

import LabeledValue from '#components/shared/LabeledValue.tsx';
import type { SwapBodyUnit } from '#domain/model/Goods.ts';
import { hasDeviation } from '#domain/model/hasDeviation.ts';

type TourServiceSwapBodyUnitDetailsProps = {
    unit: SwapBodyUnit;
};

const sectionClasses = 'display-flex flex-column gap-10 bg-lightest padding-10 rounded';
const columnClasses = 'display-grid gap-10';

export const SwapBodyUnitDetails = ({ unit }: TourServiceSwapBodyUnitDetailsProps) => {
    const intl = useIntl();

    const hasUnloadingDeviation = hasDeviation(unit.swapBodyReference.loaded, unit.swapBodyReference.unloaded);

    const emptyPlaceholder = '-';
    const loadedReference = unit.swapBodyReference.loaded;
    const unloadedReference = unit.swapBodyReference.unloaded;

    return (
        <div data-testid={`order-stop-form-${unit.id}`} className={sectionClasses}>
            <LabeledValue
                boxed
                label={intl.formatMessage({
                    id: 'intl-msg:ordercom-cloud-frontend.swap-body.reference-target',
                })}
                value={unit.swapBodyReference.target ?? emptyPlaceholder}
            />
            <div className={`${columnClasses} grid-cols-2`}>
                <LabeledValue
                    boxed
                    label={intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.swap-body.reference-loaded',
                    })}
                    value={loadedReference ?? emptyPlaceholder}
                />
                <LabeledValue
                    boxed
                    label={intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.swap-body.reference-unloaded',
                    })}
                    classNameValue={hasUnloadingDeviation ? 'text-color-danger' : ''}
                    value={unloadedReference ?? emptyPlaceholder}
                />
            </div>
        </div>
    );
};
